import React, { useState, useEffect } from 'react';
import { checkMenu, getPermissions } from '../Utils/Common';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';

import { RiFileEditFill } from "react-icons/ri";
import { AiOutlinePlus, AiFillEdit, AiFillDelete, AiOutlineClose } from 'react-icons/ai'
import { VscOpenPreview } from "react-icons/vsc";
import { GoVerified ,GoUnverified } from "react-icons/go";
import { CgBlock, CgUnblock } from "react-icons/cg";
import { BsFillLockFill, BsFillUnlockFill } from "react-icons/bs";
import { FaRecycle } from "react-icons/fa";
import { MdOutlineDeleteOutline, MdAddTask } from "react-icons/md";
import { FcApproval } from "react-icons/fc";

import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, useHistory } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import moment from 'moment'
import Badge from 'react-bootstrap/Badge';
import CloseButton from 'react-bootstrap/CloseButton';

import FileViewer from 'react-file-viewer';
import Modal from 'react-bootstrap/Modal';
import Pagination from 'react-bootstrap/Pagination';

import { Document, Page, pdfjs } from "react-pdf";
import 'react-pdf/dist/esm/Page/AnnotationLayer';
import 'react-pdf/dist/esm/Page/TextLayer';

import { defaultConf } from "../config/DefaultConf";
import { confirm } from "react-confirm-box";
import 'bootstrap/dist/css/bootstrap.min.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


function FileManager() {
	const history = useHistory()
	const [dataList, setDataList] = useState([])
	const [page, setPage] = useState(0);
	const [limit, setLimit] = useState(25);
	const [pages, setPages] = useState(0);
	const [rows, setRows] = useState(0);
	const [keyword, setKeyword] = useState("");
	const [query, setQuery] = useState("");
	const newDate = new Date(Date.now() + (1*24*60*60*1000));
	const [numPages, setNumPages] = useState(null);
	const [pageNumber, setPageNumber] = useState(1);
	const [modalShow, setModalShow] = React.useState(false);
	const [detailPreview, setDetailPreview] = useState([])
	const [fullscreen, setFullscreen] = useState(true);
	const filePath = defaultConf.uploadUrl;

	const role = getPermissions();
	useEffect(() => {
		getDataList()        
	}, [page, keyword]);


	const handlePreviewFile = async (e) => {
			const id = e.target.attributes.getNamedItem("data-id").value

			await Api().get(`files/${id}`)
			.then((response) => response)
			.then((dataPreview) => {
				console.log(dataPreview.data)
				detailPreview.id = id;
				detailPreview.filename = dataPreview.data.filename;
				setDetailPreview(dataPreview.data);
				setModalShow(true)
			})
			.catch()
	}

	const checkFileExists = async (filename) => {
			return await Api().get(`download/${filename}`).then((response) => response)
			.then((data) => {
					return data.status
					
			})
			.catch();
	}

	const handleCloseModal = () => {
			setModalShow(false)
			setPageNumber(1);
	}

	function onDocumentLoadSuccess({ numPages }) {
			setNumPages(numPages);
	}

	const getDataList = async () => {
			await Api().get(`files?filter=${keyword}&fields=filename&page=${page}&limit=${limit}`)
			.then((response) => response)
			.then((data) => {
					const listData = data.data;
					setDataList(listData.docs);
					setPage(listData.page);
					setPages(listData.totalPages);
					setRows(listData.totalDocs);
			})
			.catch((err) => {
			})
	}

	const changePage = ({ selected }) => {
			setDataList([])
			setPage(selected+1);
	}

	const searchData = (e) => {
			e.preventDefault();
			setPage(0);
			setKeyword(query);
	}

	function fileSizeFormat(size){
			size = size/1024;
			let formatSize = '';
			if( size < 1000 )
			{
					formatSize = size.toFixed(2) + ' KB'
			}
			else if( size >= 1000 && size < 1000000 )
			{
					formatSize = (size/1000).toFixed(2) + ' MB'
			}
			else if( size >= 1000000 && size < 1000000000 )
			{
					formatSize = (size/1000000).toFixed(2) + ' GB'
			}
			else if( size >= 1000000000 && size < 1000000000000 )
			{
					formatSize = (size/1000000000).toFixed(2) + ' TB'
			}
			return formatSize
	}

	const handleDeleteFile = async (e) => {
			const id = e.target.attributes.getNamedItem("data-id").value

			const confirm_action = await confirm("Anda yakin ini menghapus selamanya file ini?");
			if (confirm_action) {
					await Api().delete(`files/${id}`)
					.then((response) => response)
					.then((res) => {
						if( res.status === 200 || res.status === 201 ){
							getDataList()
						}
					})
					.catch((err) => {
							
					});
			}
	}


	const handleSendTask = async (e) => {
			const id = e.target.attributes.getNamedItem("data-id").value
			const statusData = {};

			const confirm_action = await confirm("Anda yakin ingin mengirik task ini ke dokter?");
			if (confirm_action) {
					await Api().get(`files/${id}`)
					.then((response) => response)
					.then((dataFile) => {
							console.log(dataFile);
							if( dataFile.status === 200 || dataFile.status === 201 )
							{
									statusData.status = 'Task'
									Api().patch(`updatestatusfile/${id}`, statusData)
									.then((response) => response)
									.then((res) => {
											console.log(res)
											if( res.status === 200 || res.status === 201 ){
													getDataList();
													history.push('/filemanager')
											}
									})
									.catch((err) => {
											
									});
							}
					}).catch((err) => {
					});
			}
	}

	const handleRecycledBin = async (e) => {
			const id = e.target.attributes.getNamedItem("data-id").value
			const statusData = {};

			const confirm_action = await confirm("Anda yakin ingin menghapus list ini?");
			if (confirm_action) {
					await Api().get(`files/${id}`)
					.then((response) => response)
					.then((dataFile) => {
							console.log(dataFile);
							if( dataFile.status === 200 || dataFile.status === 201 )
							{
									statusData.status = 'Deleted'
									Api().patch(`updatestatusfile/${id}`, statusData)
									.then((response) => response)
									.then((res) => {
											console.log(res)
											if( res.status === 200 || res.status === 201 ){
													getDataList();
													history.push('/filemanager')
											}
									})
									.catch((err) => {
											
									});
							}
					}).catch((err) => {
					});
			}
	}

	function setBadge(status){
			switch(status)
			{
					case 'Uploaded':
							return 'success'
							break
							
					case 'Moderator':
							return 'secondary'
							break
					
					case 'Task':
							return 'primary'
							break
			
					case 'Edited':
							return 'info'
							break
	
					case 'Locked':
							return 'warning'
							break

					case 'Deleted':
							return 'danger'
							break
			}
	}

	const handleStartEditing = async (e) => {
			const id = e.target.attributes.getNamedItem("data-id").value
			const statusData = {};

			const confirm_action = await confirm("Anda yakin sudah siap memulai pengubahan data?");
			if (confirm_action) {
					await Api().get(`files/${id}`)
					.then((response) => response)
					.then((dataFile) => {
							console.log(dataFile);
							if( dataFile.status === 200 || dataFile.status === 201 )
							{
									statusData.status = 'Moderator'

									Api().patch(`updatestatusfile/${id}`, statusData)
									.then((response) => response)
									.then((res) => {
											console.log(res)
											if( res.status === 200 || res.status === 201 ){
													getDataList();
													history.push('/listmedical')
											}
									})
									.catch((err) => {
											
									});
							}
					}).catch((err) => {
					});
			}
	}

	const handleLockFile = async (e) => {
			const id = e.target.attributes.getNamedItem("data-id").value
			const statusData = {};

			const confirm_action = await confirm("Anda yakin ingin mengunci file ini?");
			if (confirm_action) {
					await Api().get(`files/${id}`)
					.then((response) => response)
					.then((dataFile) => {
							console.log(dataFile);
							if( dataFile.status === 200 || dataFile.status === 201 )
							{
									statusData.status = dataFile.data.status;
									if( dataFile.data.status !== 'Locked' )
									{
											statusData.status = 'Locked'
									}
									else if( dataFile.data.status === 'Locked' ){
											
											statusData.status = 'Moderator'
									}
									Api().patch(`updatestatusfile/${id}`, statusData)
									.then((response) => response)
									.then((res) => {
											console.log(res)
											if( res.status === 200 || res.status === 201 ){
													getDataList();
													history.push('/filemanager')
											}
									})
									.catch((err) => {
											
									});
							}
					}).catch((err) => {
					});
			}
	}

	const handleApproveTask = async (e) => {
		const id = e.target.attributes.getNamedItem("data-id").value
		const statusData = {};

		const confirm_action = await confirm("Anda yakin ingin menerima tugas ini?");
		if (confirm_action) {
			await Api().get(`files/${id}`)
			.then((response) => response)
			.then((dataFile) => {
				console.log(dataFile);
				if( dataFile.status === 200 || dataFile.status === 201 )
				{
					statusData.status = 'Edited'
					Api().patch(`updatestatusfile/${id}`, statusData)
					.then((response) => response)
					.then((res) => {
						console.log(res)
						if( res.status === 200 || res.status === 201 ){
							getDataList();
							history.push('/listmedicaldoctor')
						}
					})
					.catch((err) => {
							
					});
				}
			}).catch((err) => {
			});
		}
	}


	return (
		<>
			<div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
				<DefaultLayout />
				<main>
					<div className="content-header">
						<Container fluid>
							<Row className="mb-2">
								<Col sm={6}>
									<h1 className="m-0">File Manager</h1>
								</Col>
								<Col sm={6}>
									<Breadcrumb className="breadcrumb float-sm-right">
										<Breadcrumb.Item href="/">Home</Breadcrumb.Item>
										<Breadcrumb.Item active>File Manager</Breadcrumb.Item>
									</Breadcrumb>
								</Col>
							</Row>
						</Container>
					</div>
					<div className="content">
						<Container fluid>
							<Row>
								<Col lg={12}>
									<Card className="content-list">
										<Card.Header>
											<Row>
												<Col lg={6}>
													{ checkMenu('upload') &&
														<Link to="upload"><Button variant="outline-primary"><AiOutlinePlus /> Upload File(s)</Button></Link>
													}
												</Col>
												<Col lg={6}>
													<Navbar bg="light" expand="lg" className='float-sm-right'>
														<Navbar.Collapse id="navbarScroll">
															<Form className="d-flex" onSubmit={searchData}>
																<Form.Control
																	type="search"
																	placeholder="Search"
																	className="me-2"
																	aria-label="Search"
																	value={query}
																	onChange={(e) => setQuery(e.target.value)}
																/>
																<Button type="submit" variant="outline-primary">Search</Button>
															</Form>
														</Navbar.Collapse>
													</Navbar>
												</Col>
											</Row>
										</Card.Header>
										<Card.Body>
											<Table striped hover responsive>
												<thead>
													<tr>
														<th style={{ width: '5%'}} className="text-center">No</th>
														<th style={{ width: '30%'}} className="text-left">File Name</th>
														<th style={{ width: '10%'}} className="text-left">Type</th>
														<th style={{ width: '5%'}} className="text-left">Size</th>
														<th style={{ width: '35%'}} className="text-left">Project</th>
														<th style={{ width: '10%'}} className="text-left">Folder</th>
														<th style={{ width: '5%'}} className="text-left"></th>
													</tr>
												</thead>
												<tbody>
													{
														dataList.map((item, i) => (
															<tr key={i}>
																<td className="text-center">
																		{page === 1 ?
																				i+1 : ( limit * (page-1) ) + (i+1)
																		}
																</td>
																<td className="text-left">
																	{ item.mimetype !== 'application/pdf' &&
																		<>
																			<img src={filePath + item.uploadFile} width={200} />
																		</>
																	}
																	{/* <Link to="#" onClick={handlePreviewFile} data-id={item._id}>{item.filename}</Link> */}
																</td>
																<td className="text-left">
																	{item.mimetype}

																	<br />
																	<Button type="button" onClick={handlePreviewFile} data-id={item._id}>Preview</Button>
																</td>
																<td className="text-right">{fileSizeFormat(item.size)}</td>
																<td className="text-left">
																	{ item.projectId !== null ? item?.projectId?.projectName : "" }
																</td>
																<td className="text-left">
																	{ item.folder }
																</td>
																<td className="text-left">
																	<NavDropdown title="Action" className='' id="basic-nav-dropdown">
																		{ checkMenu('previewfile') && 
																			<NavDropdown.Item onClick={handlePreviewFile} data-id={item._id}><VscOpenPreview /> Preview</NavDropdown.Item>
																		}

																		{ checkMenu('deletefile') && 
																			<NavDropdown.Item href="#" onClick={handleDeleteFile} data-id={item._id}><MdOutlineDeleteOutline /> Delete</NavDropdown.Item> 
																		}
																	</NavDropdown>
																</td>
															</tr>
														))
													}
												</tbody>
											</Table>
										</Card.Body>
										<Card.Footer>
											<Row>
												<Col lg={3}>
													<p>Total Data: {rows} Page: {rows ? page : 0} of {pages}</p>
												</Col>
												<Col lg={9}>
													<nav
														className="pagination float-sm-right"
														key={rows}
														role="navigation"
														aria-label="pagination"
													>
														<ReactPaginate
															previousLabel={"Prev"}
															nextLabel={"Next"}
															pageCount={pages}
															onPageChange={changePage}
															containerClassName={"pagination-list pagination"}
															pageLinkClassName={"pagination-link page-link"}
															previousLinkClassName={"pagination-previous page-link"}
															nextLinkClassName={"pagination-next page-link"}
															activeLinkClassName={"pagination-link is-current"}
															disabledLinkClassName={"pagination-link is-disabled"}
															activeClassName={"active"}
															pageClassName={"page-item"}
														/>
													</nav>
												</Col>
											</Row>
										</Card.Footer>
									</Card>
								</Col>
							</Row>
						</Container>
					</div>
				</main>
			</div>
			<Footer />
			<Modal 
				show={modalShow} 
				fullscreen={fullscreen} 
				onHide={handleCloseModal}
        dialogClassName="modal-full-custom"
				scrollable={fullscreen}
			>
				<Modal.Header closeButton>
					<Modal.Title className='text-center'>
						{ detailPreview.mimetype === 'application/pdf' ? "Preview PDF" : "Preview Image"}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="file-preview-container">
						{ detailPreview.mimetype === 'application/pdf' ?
							<iframe src={filePath + detailPreview.uploadFile} style={{width: "100%", height: "100%", position: "absolute", left: "0px", top: "0px"}}/>
							:
							<img src={filePath + detailPreview.uploadFile} style={{height: "100vh"}}/>
						}
						
					</div>
				</Modal.Body>
				
			</Modal>
		</>
	)
}
export default FileManager